// extracted by mini-css-extract-plugin
export default {"container":"Q3t7RSysgCl9mZPwwvs9WA==","illustration":"g2aThMyD+oEPjeMSt4NLiw=="};